import styled from 'styled-components';

export const DescriptionVessel = styled.div`
  border: 1px solid var(--neutral_lighter);
  border-radius: 5px;
  padding-top: 15px;
  padding-right: 15px;
  padding-left: 15px;
`;
